import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Every date shown in the app uses the US calendar: MM/DD/YYYY. Date-only
// strings ("2026-09-29") are read as that local calendar day — `new Date()`
// would treat them as UTC midnight and show the previous day in US timezones.
const US_DATE = { month: "2-digit", day: "2-digit", year: "numeric" };

function toDate(value) {
  if (!value) return null;
  const s = String(value);
  const d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(s) ? `${s}T00:00:00` : s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function fmtDate(value, fallback = "—") {
  const d = toDate(value);
  return d ? d.toLocaleDateString("en-US", US_DATE) : fallback;
}

export function fmtDateTime(value, fallback = "—") {
  const d = toDate(value);
  return d ? d.toLocaleString("en-US", { ...US_DATE, hour: "numeric", minute: "2-digit" }) : fallback;
}
